export const getSubtaskEstimatedHours = (ticket) =>
  (ticket?.subtasks || []).reduce(
    (total, subtask) => total + (Number(subtask?.time_estimate) || 0),
    0
  );

export const getTicketHoursIncludingSubtasks = (ticket) =>
  (Number(ticket?.total_hours_spent) || 0) + getSubtaskEstimatedHours(ticket);
